import {Component, Input, OnInit} from '@angular/core';
import {sprintf} from "sprintf-js";
import {BranchOutside} from "./OutsideStruct";
import {VariableValue} from "../../../variableDataBase/VariableValue";
import {VariableDataBase} from "../../../variableDataBase/variable-data-base.service";
import {
  faSun, faMoon
} from '@fortawesome/free-solid-svg-icons';
import {IconDefinition} from "@fortawesome/fontawesome-common-types";
import {BranchMeasurement} from "../../CardStruct";


@Component({
  selector: 'app-branch-type-out-side-overview',
  templateUrl: './branch-type-out-side-overview.component.html',
  styleUrls: ['./branch-type-out-side-overview.component.css']
})
export class BranchTypeOutSideOverviewComponent implements OnInit {
  @Input() branchOutside: BranchOutside | undefined;
  outsideTemperature: &VariableValue = new VariableValue();
  outsideHumidity: &VariableValue = new VariableValue();
  dewPoint: &VariableValue = new VariableValue();
  absHumidity: &VariableValue = new VariableValue();
  sunRise: &VariableValue = new VariableValue();
  sunSet: &VariableValue = new VariableValue();
  radiation: &VariableValue = new VariableValue();
  radiationsum: &VariableValue = new VariableValue();


  iconSun: IconDefinition = faSun;
  iconMoon: IconDefinition = faMoon;

  constructor(private variableDB: VariableDataBase) {
  }

  GetValue(variable: VariableValue) : string
  {
    if(variable.IsInvalid())
      return "NaN";
    return sprintf("%5.1f", variable.val / 1);
  }

  GetTime(variable: VariableValue): string
  {
    if(variable.IsInvalid())
      return "NaN";
    return sprintf("%2d:%02d ", (variable.val*100) / 100,  (variable.val*100) % 100, );
  }

  ngOnInit(): void {
    if( this.branchOutside ) {

      this.outsideTemperature = this.variableDB.AddValueByReference(this.branchOutside.outsidetemp.variable.id);
      this.outsideHumidity = this.variableDB.AddValueByReference(this.branchOutside.outsidehumidity.variable.id);
      this.dewPoint = this.variableDB.AddValueByReference(this.branchOutside.dewpoint.variable.id);
      this.absHumidity = this.variableDB.AddValueByReference(this.branchOutside.abshumidity.variable.id);
      this.sunRise = this.variableDB.AddValueByReference(this.branchOutside.sunrise.variable.id);
      this.sunSet = this.variableDB.AddValueByReference(this.branchOutside.sunset.variable.id);
      this.radiation = this.variableDB.AddValueByReference(this.branchOutside.radiation.variable.id);
      this.radiationsum = this.variableDB.AddValueByReference(this.branchOutside.radiationsum.variable.id);
    }
  }
}
